import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Text, VStack } from '@chakra-ui/react'
import { PaymentBillingType, PaymentCommuneType, PaymentSubscriptionType } from 'context/types'
import { BILLING_INFORMATION_SCHEMA } from 'context/validations'
import { Formik, FormikProps } from 'formik'

import { CardBody, CardContainer } from 'components/CustomCard'
import { InputControl, SubmitButton } from 'components/InputCustom'
import { customToast } from 'components/ToastCustom'

import { CommuneListArr } from './communeListArr'

type BillingRouterProps = { subscription: PaymentSubscriptionType }

export const Billing = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const [subscription, setSubscription] = useState<PaymentSubscriptionType | null>(null)
  const [communnes, setCommunnes] = useState<PaymentCommuneType[] | null | undefined>(null)
  const [communeSelected, setCommuneSelected] = useState<string | null>(null)

  useEffect(() => {
    let subscription = null

    if (location.state) ({ subscription } = location.state as BillingRouterProps)

    subscription && setSubscription(subscription)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  useEffect(() => {
    if (!communnes) setCommunnes(CommuneListArr)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const initialValues: PaymentBillingType = {
    commune: '',
    street: '',
    streetNumber: '',
    towerApartmentHouse: '',
  }

  const handleOnSubmit = (values: PaymentBillingType) => {
    if (subscription && communeSelected) {
      const data: PaymentBillingType = {
        ...values,
        commune: communeSelected,
      }

      subscription.billing = data
      navigate('/contract-subscription', { state: { subscription } })
    } else {
      customToast.showToast({ description: 'Hubo un error al ingresar los datos' })
      navigate('/my-vehicles')
    }
  }

  const handleOnChange: (value: string) => void = (value: string) => {
    if (value.length < 1) {
      setCommunnes(null)
      setCommuneSelected(null)

      return
    }

    if (CommuneListArr) {
      const commune: PaymentCommuneType[] = CommuneListArr.filter(
        (commune: PaymentCommuneType) =>
          commune.commune.toLowerCase().includes(value.toLowerCase()),
      )

      setCommunnes(commune)
    }
  }

  return (
    <Formik
      enableReinitialize
      validateOnMount
      initialValues={initialValues}
      onSubmit={handleOnSubmit}
      validationSchema={BILLING_INFORMATION_SCHEMA}>
      {({
        isValid,
        values,
        setFieldValue,
      }: FormikProps<PaymentBillingType>) => (
        <CardContainer isScreen hiddenStack>
          <CardBody>
            <VStack w='full' spacing={8} padding={4}>
              <Text variant={'LG_SB'}>
                Datos de facturación
              </Text>
              <Text variant={'MD'}>
                Completa los siguientes datos de tu dirección para la facturación
              </Text>
              <InputControl
                name='street'
                label=''
                inputProps={{ placeholder: 'Calle' }}
              />
              <InputControl
                name='streetNumber'
                label=''
                inputProps={{ placeholder: 'Número calle' }}
              />
              <InputControl
                name='towerApartmentHouse'
                label=''
                inputProps={{ placeholder: 'Torre/Departamento/Casa (opcional)' }}
              />
              <InputControl
                name='commune'
                label=''
                inputProps={{ placeholder: 'Comuna', autoComplete: 'new-password' }}
                inputType={'contact'}
                handleOnChange={handleOnChange}
                availableElements={communnes && communnes.length >= 1 && values.commune.length > 0 || false}
                {...(communnes && {
                  SelectionElement: communnes.map(item => {
                    return (
                      <VStack
                        alignItems={'center'}
                        justifyContent={'center'}
                        key={item.key}
                        _hover={{ opacity: 0.5 }}
                        onClick={() => {
                          setFieldValue('commune', item.commune)
                          setCommuneSelected(item.code)
                          setCommunnes(null)
                        }}
                      >
                        <Text
                          marginY={2}
                          marginLeft={5}
                          variant={'TXT_M'}>
                          {item.commune}
                        </Text>
                      </VStack>
                    )
                  }),
                })}
              />
              <SubmitButton disabled={!isValid || !communeSelected}>
                Siguiente
              </SubmitButton>
            </VStack>
          </CardBody>
        </CardContainer>
      )}
    </Formik>
  )
}
